export enum AnnualPlanStatus {
  NoPlan = 'No Plan',
  NotStarted = 'Not Started',
  Drafting = 'Drafting',
  ReadyToSubmit = 'Ready to Submit',
  Submitted = 'Submitted',
  NeedsRevision = 'Needs Revision',
  PlanAccepted = 'Plan Accepted',
  Finalized = 'Finalized',
  Updating = 'Updating',
  UpdatesSubmitted = 'Updates Submitted',
  UpdatesAccepted = 'Updates Accepted',
  UpdatesNeedsRevision = 'Updates Needs Revision',
  ProgressTracking = 'Progress Tracking',
  ImplementationComplete = 'Implementation Complete'
}

export const PassedContractPhase = [
  AnnualPlanStatus.Updating,
  AnnualPlanStatus.UpdatesSubmitted,
  AnnualPlanStatus.UpdatesAccepted,
  AnnualPlanStatus.ProgressTracking,
  AnnualPlanStatus.ImplementationComplete
]

export const ImplementationPhaseStatuses = [
  AnnualPlanStatus.Finalized,
  AnnualPlanStatus.Updating,
  AnnualPlanStatus.UpdatesSubmitted,
  AnnualPlanStatus.UpdatesNeedsRevision,
  AnnualPlanStatus.UpdatesAccepted,
  AnnualPlanStatus.ProgressTracking,
  AnnualPlanStatus.ImplementationComplete,
  AnnualPlanStatus.ReadyToSubmit
]
